import { useState } from 'react'
import { Card, CardBody, Accordion, AccordionBody, AccordionHeader, AccordionItem} from 'reactstrap'
import './accordion.css'
import Pdf_image from '../../assets/PDF.png'
import Pdfdownload_icon from '../../assets/pdf-down-icon.svg'
import { beforeTestFAQs, afterTestFAQs, afterResultFAQ } from 'constants/faqsDataTwo'
import ShowAllBranches from 'components/Result/AntheResults/components/ShowAllBranches'
import TripWinner from './TripWinner'
const Faqtwo = ({ profileData, isResultPage, isResultAwaited }) => {
    let date = new Date();
    const [open, setOpen] = useState('')
    const toggle = (id) => {
        if (open === id) {
            setOpen('')
        } else {
            setOpen(id)
        }
    }
    const data = isResultPage ? afterResultFAQ : (profileData.exam_taken ? afterTestFAQs : beforeTestFAQs)

    return data && data.length ? (
        <Card
            className="border-0 p-0"
            style={{
                width: '100%',
                filter: 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))',
            }}
        >
            <CardBody className="p-4">
                <div className="advantage_heading">
                    <h3 className="font-size-lg text-grey-black p-1 pb-0">FAQs</h3>
                </div>
                <Accordion flush open={open} toggle={toggle}>
                    {data.map((obj, key) => (
                        <AccordionItem key={key} className="item">
                            <AccordionHeader
                                targetId={`${key} + 1`}
                                onClick={() => {
                                    window.webengage.track('ANTHE_db_faqs', {
                                        'mobile number': profileData.mobile_number,
                                        class:
                                            profileData.class &&
                                            profileData.class.toString(),
                                        stream: profileData.stream,
                                        branchcode: profileData.exam_center_id,
                                        Year: date.getFullYear()
                                    })
                                }}
                            >
                                <p className="font-size-xs m-0 fw-700 text-grey-black p-0 ">
                                    {obj?.question}
                                </p>
                            </AccordionHeader>
                            <AccordionBody accordionId={`${key} + 1`}>
                            {obj.type === 'video' ? (
                                <div className={isResultPage?"col-lg-4":""}>
                                    <iframe
                                        title="ANTHE banner video"
                                        width="100%"
                                        height="200px"
                                        src={obj?.faq_video}
                                        className="rounded"
                                    ></iframe>
                                </div>
                                ) : obj.type === 'pdf' ? (
                                    <div className={`${isResultPage?"col-lg-4":""} bg-light mb-3 p-3 d-flex justify-content-between align-items-center rounded`}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <img src={Pdf_image} alt="pdf-icon" />
                                            <p className="mb-0 font-size-xs fw-lighter ps-3">
                                                Sample papers.pdf
                                            </p>
                                        </div>
                                        <a
                                            href={obj?.faq_pdf}
                                            download
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={Pdfdownload_icon}
                                                alt="pdf-download-icon"
                                            />
                                        </a>
                                    </div>
                                ) : (
                                    ''
                                )}
                                <p
                                    className="font-size-xs fw-normal mb-0"
                                    dangerouslySetInnerHTML={{ __html: obj?.answer }}
                                ></p>
                            </AccordionBody>
                        </AccordionItem>
                    ))}
                    {/* Accordion with google maps if exam taken then only include gmap accordion item*/}
                    {isResultPage || isResultAwaited ? (
                        <>
                            {/* Trip Winner Carousel */}
                            {!isResultAwaited && 
                            <AccordionItem key={`tripWinner`} className="item">
                                <AccordionHeader targetId={`trip-winner`}>
                                    <p className="font-size-xs m-0 fw-700 text-grey-black p-0 ">
                                        ANTHE trip winners
                                    </p>
                                </AccordionHeader>
                                <AccordionBody accordionId={`trip-winner`}>
                                    <TripWinner />
                                </AccordionBody>
                            </AccordionItem>
                            }
                            <AccordionItem key={`gmap`} className="item">
                                <AccordionHeader
                                    targetId={`google-map-faq`}
                                    onClick={() => {
                                        window.webengage.track('ANTHE_db_faqs', {
                                            'mobile number': profileData.mobile_number,
                                            class:
                                                profileData.class &&
                                                profileData.class.toString(),
                                            stream: profileData.stream,
                                            branchcode: profileData.exam_center_id,
                                            Year: date.getFullYear()
                                        })
                                    }}
                                >
                                    <p className="font-size-xs m-0 fw-700 text-grey-black p-0 ">
                                        How many branches are there nationwide?
                                    </p>
                                </AccordionHeader>
                                <AccordionBody accordionId={`google-map-faq`}>
                                    {/* google maps component */}
                                    <ShowAllBranches />
                                </AccordionBody>
                            </AccordionItem>
                        </>
                    ) : (<></>)}
                </Accordion>
            </CardBody>
        </Card>
    ) : (
        ''
    )
}
export default Faqtwo
